import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState, useRef } from 'react';
import PreferencesHeader from '../header/PreferencesHeader';
import SpectraPanelHeader from './SpectraPanelHeader';
import SpectraPreferences from './SpectraPreferences';
import SpectraTabs from './SpectraTabs';
const styles = {
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
};
function SpectrumListPanel() {
    const settingsRef = useRef();
    const [isFlipped, setFlipStatus] = useState(false);
    function settingsPanelHandler() {
        setFlipStatus(!isFlipped);
    }
    function saveSettingHandler() {
        const isValid = settingsRef.current.saveSetting();
        if (isValid) {
            setFlipStatus(!isFlipped);
        }
    }
    return (_jsx("div", { style: styles, children: isFlipped ? (_jsxs(_Fragment, { children: [_jsx(PreferencesHeader, { onSave: saveSettingHandler, onClose: settingsPanelHandler }), _jsx(SpectraPreferences, { ref: settingsRef })] })) : (_jsxs(_Fragment, { children: [_jsx(SpectraPanelHeader, { onSettingClick: settingsPanelHandler }), _jsx(SpectraTabs, {})] })) }));
}
export default memo(SpectrumListPanel);
